var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7622 13.1584C14.159 13.1584 13.6193 13.3931 13.2066 13.7608L7.5479 10.514C7.58758 10.3341 7.61933 10.1541 7.61933 9.96636C7.61933 9.7786 7.58758 9.59866 7.5479 9.41872L13.1431 6.20326C13.5717 6.59443 14.1352 6.83696 14.7622 6.83696C16.0796 6.83696 17.1431 5.78861 17.1431 4.48991C17.1431 3.19121 16.0796 2.14286 14.7622 2.14286C13.4447 2.14286 12.3812 3.19121 12.3812 4.48991C12.3812 4.67768 12.413 4.85762 12.4527 5.03756L6.85742 8.25302C6.42885 7.86184 5.86536 7.61931 5.23837 7.61931C3.92091 7.61931 2.85742 8.66766 2.85742 9.96636C2.85742 11.2651 3.92091 12.3134 5.23837 12.3134C5.86536 12.3134 6.42885 12.0709 6.85742 11.6797L12.5082 14.9343C12.4685 15.0986 12.4447 15.2707 12.4447 15.4428C12.4447 16.7024 13.4844 17.7273 14.7622 17.7273C16.04 17.7273 17.0796 16.7024 17.0796 15.4428C17.0796 14.1832 16.04 13.1584 14.7622 13.1584Z",
    fill: "#015EF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.ea5198cfdaba51ee050a643be211eb1e.svg";
export { ForwardRef as ReactComponent };